var _path, _rect, _rect2, _rect3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInvoice(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 47,
    viewBox: "0 0 39 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.927 4a3 3 0 013-3H34.07a3 3 0 013 3v41.628l-8.103-2.604-.306.952.306-.952a2 2 0 00-1.35.046L20.4 45.935l-8.633-2.913a2 2 0 00-1.226-.017l-8.613 2.642V4z",
    stroke: "#000",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7.953,
    y: 15,
    width: 21.081,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 7.953,
    y: 20,
    width: 18.07,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 7.953,
    y: 25,
    width: 12.046,
    height: 2,
    rx: 1,
    fill: "#2C2D2E"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzkiIGhlaWdodD0iNDciIHZpZXdCb3g9IjAgMCAzOSA0NyIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuOTI2NzYgNEMxLjkyNjc2IDIuMzQzMTUgMy4yNjk5IDEgNC45MjY3NiAxSDM0LjA2OTZDMzUuNzI2NSAxIDM3LjA2OTYgMi4zNDMxNSAzNy4wNjk2IDRWNDUuNjI4M0wyOC45NjcxIDQzLjAyNDRMMjguNjYxMSA0My45NzY0TDI4Ljk2NzEgNDMuMDI0NEMyOC41MjU1IDQyLjg4MjUgMjguMDQ4MyA0Mi44OTg0IDI3LjYxNzIgNDMuMDY5NkwyMC4zOTg4IDQ1LjkzNTJMMTEuNzY1OSA0My4wMjIxQzExLjM2OTEgNDIuODg4MiAxMC45NDAzIDQyLjg4MjMgMTAuNTM5OSA0My4wMDUxTDEuOTI2NzYgNDUuNjQ3M0wxLjkyNjc2IDRaIiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIiLz4KPHJlY3QgeD0iNy45NTMxMiIgeT0iMTUiIHdpZHRoPSIyMS4wODExIiBoZWlnaHQ9IjIiIHJ4PSIxIiBmaWxsPSIjMkMyRDJFIi8+CjxyZWN0IHg9IjcuOTUzMTIiIHk9IjIwIiB3aWR0aD0iMTguMDY5NSIgaGVpZ2h0PSIyIiByeD0iMSIgZmlsbD0iIzJDMkQyRSIvPgo8cmVjdCB4PSI3Ljk1MzEyIiB5PSIyNSIgd2lkdGg9IjEyLjA0NjMiIGhlaWdodD0iMiIgcng9IjEiIGZpbGw9IiMyQzJEMkUiLz4KPC9zdmc+Cg==";
export { SvgInvoice as ReactComponent };